import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/business-types/save`,
        endpointGetById: `${endpointBackend}gci/business-types/getById`,
        urlGoBack: `/gci/business-types/list`,
        pathView: `/gci/business-types/view`
    }

    const labels = {
        labelTitleAdd: "Novo Tipo de Negócio",
        labelTitleEdit: "Editar Tipo de Negócio",
        labelTitleView: 'Visualizar Tipo de Negócio'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'business_type',
                    type: 'text',
                    label: 'Tipo de Negócio',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
